import type { Customer } from '@/domain';
import { mockStore } from '@/lib/mock-store';
import { getSupabase, isMockBackend } from '@/lib/supabase';

export const customerService = {
  async list(): Promise<Customer[]> {
    if (isMockBackend) return mockStore.getAll('customers');
    const supabase = getSupabase()!;
    const { data, error } = await supabase
      .from('customers')
      .select('*')
      .order('code', { ascending: true });
    if (error) throw error;
    return (data ?? []) as Customer[];
  },
  async getById(id: string): Promise<Customer | null> {
    const all = await this.list();
    return all.find((c) => c.id === id) ?? null;
  },
};
